'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _index = require('../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _dofSpinner = require('../dof-spinner');

var _dofSpinner2 = _interopRequireDefault(_dofSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animation = weex.requireModule('animation');
var timer = null;
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default, DofSpinner: _dofSpinner2.default },
  props: {
    mutilTabGroups: { type: Array, default: function _default() {
        return [];
      } },
    mutilTabBarContainerStyle: {
      type: Object,
      default: function _default() {
        return {
          justifyContent: 'space-around',
          paddingLeft: '64px',
          paddingRight: '64px'
        };
      }
    },
    tabGroups: { type: Array, default: function _default() {
        return [];
      } },
    iconColor: { type: String, default: '' },
    iconTextColor: { type: String, default: '' },
    tabBarPosition: { type: Object, default: function _default() {
        return { position: 'fixed' };
      } },
    hasTopBorder: { type: Boolean, default: false },
    supportXBar: { type: Boolean, default: true },
    bottomLine: { type: Boolean, default: true },
    warpStyle: { type: Object, default: function _default() {
        return {};
      } },
    showAnimate: { type: Boolean, default: true }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    var supportXBar = this.supportXBar;

    this.isIPhoneX = _index2.default.env.isIPhoneX() && supportXBar;
  },

  computed: {
    _iconTextColor: function _iconTextColor() {
      return this.iconTextColor ? this.iconTextColor : this._theme === 'colmo' ? 'rgba(255,255,255,0.80)' : '#ffffff';
    },
    _iconColor: function _iconColor() {
      return this.iconColor ? this.iconColor : this._theme === 'colmo' ? '#B35336' : this._isDiablo ? '#0490D3' : '#00A4F2';
    },
    newTabBarStyle: function newTabBarStyle() {
      var tabBarPosition = this.tabBarPosition;

      if (tabBarPosition.position === 'fixed') {
        return _extends({ position: 'fixed', left: 0, right: 0, bottom: 0 }, this.warpStyle);
      } else {
        return _extends({ left: 0, right: 0 }, this.warpStyle, tabBarPosition);
      }
    }
  },
  methods: {
    widthMap: function widthMap(item) {
      return item.width ? Number(item.width) : item.size === 'big' ? 304 : 96;
    },
    widthCalc: function widthCalc(item) {
      return this.widthMap(item) + 'px';
    },
    widthCalcSmall: function widthCalcSmall(item) {
      return this.widthMap(item) - 2 + 'px';
    },
    widthCalcBig: function widthCalcBig(item) {
      return this.widthMap(item) + 14 + 'px';
    },
    handleBg: function handleBg(item) {
      var bg = item.iconColor ? item.iconColor : this._iconColor;
      if (bg === 'transparent') bg = this._isColmo ? '#151617' : this._isDiablo ? '#171C1F' : '#ffffff';
      return bg;
    },
    handleIconTextColor: function handleIconTextColor(item) {
      if (item.iconTextColor) return item.iconTextColor;
      var isDark = new _color2.default(this.handleBg(item)).isDark();
      var color = isDark ? '#ffffff' : '#1E2E37';
      return color;
    },
    resolveLoadingIcon: function resolveLoadingIcon(backgroudColor) {
      if (this._isColmo) return 'colmo';
      if (backgroudColor === 'transparent') return 'black';

      var color = new _color2.default(backgroudColor);
      return color.isDark() ? 'white' : 'black';
    },
    tabBarItemClicked: function tabBarItemClicked(target, index, source) {
      if (target && !target.disabled) {
        this.$emit('dofTabItemClicked', { target: target, index: index });
      }
    },
    _animationFn: function _animationFn(el, styles, options, callback) {
      var _options$timing = options.timing,
          timing = _options$timing === undefined ? 'linear' : _options$timing,
          _options$duration = options.duration,
          duration = _options$duration === undefined ? 500 : _options$duration,
          _options$delay = options.delay,
          delay = _options$delay === undefined ? 0 : _options$delay;
      // Core.alert(timing)

      animation.transition(el, {
        styles: styles,
        timingFunction: timing,
        duration: duration,
        delay: delay
      }, function () {
        callback && callback();
      });
    },
    shrinkCircleFn: function shrinkCircleFn(target, index, source) {
      if (this._isColmo || !this.showAnimate) return;
      if (target && !target.disabled) {
        var elCircle = this.$refs['animate-circle-' + index][0];
        var elImg = this.$refs['animate-circle-bg-' + index][0];
        var scale = target.width && target.width > 500 ? 'scale(0.98,0.98)' : 'scale(0.95,0.95)';
        this._animationFn(elCircle, {
          transform: scale,
          transformOrigin: 'center center'
        }, { duration: 100 }, function () {});
        this._animationFn(elImg, { transform: scale, transformOrigin: 'center center' }, { duration: 100 }, function () {});
      }
    },
    expandCircleFn: function expandCircleFn(target, index, source) {
      var _this = this;

      if (this._isColmo || !this.showAnimate) return;
      if (target && !target.disabled) {
        var elCircle = this.$refs['animate-circle-' + index][0];
        var elImg = this.$refs['animate-circle-bg-' + index][0];
        timer = setTimeout(function () {
          _this._animationFn(elImg, { transform: 'scale(1,1)', transformOrigin: 'center center' }, { duration: 100 }, function () {});
          _this._animationFn(elCircle, {
            transform: 'scale(1.2,1.2)',
            opacity: 0,
            transformOrigin: 'center center'
          }, {}, function () {
            animation.transition(elCircle, {
              styles: {
                transform: 'scale(1,1)',
                opacity: 1,
                transformOrigin: 'center center'
              },
              duration: 0,
              timingFunction: 'linear',
              delay: 0
            });
          });
        }, 100);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(timer);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-bottom-bar/index.vue
// module id = 309
// module chunks = 0 1